export enum TabsAlign {
  LEFT = 'left',
  CENTER = 'center',
}
